import {
  CoherenceDataGrid,
  CoherencePanel,
} from "@coherence-design-system/controls";
import React, { useEffect, useState } from "react";
import {
  ActionButton,
  ComboBox,
  IIconProps,
  IObjectWithKey,
  IStackProps,
  IStackTokens,
  PrimaryButton,
  SelectionMode,
  Stack,
  TextField,
  Selection,
  SpinnerSize,
  Spinner,
  MessageBar,
  MessageBarType,
  Separator,
  IComboBoxOption,
  DefaultButton,
} from "@fluentui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { useBoolean } from "@fluentui/react-hooks";
import {
  DisabledMediumTextFieldStyles,
  DisabledRegisterCountryBoxStyles,
  EditButtonStyle,
  MediumTextFieldStyles,
  RegisterCountryBoxStyles,
  SaveAndBackButtonStyleShipping,
} from "../CustomerStyle";
import {
  CustomerContact,
  ICustomerEditAddressProps,
  ResponseAddress,
  ResponseCustomerEditAccount,
} from "../Customer.types";
import { v4 as uuidv4 } from "uuid";
import {
  customerInfoIntialValue,
  newAddressCustomerInfoIntialValue as newAddressIntialValue,
  editAddressCustomerInfoIntialValue as customerErrorsIntialValue,
  countryWiseStateList,
} from "../CustomerFormInitialValues";
import { CustomerService } from "../../../services/Customers/CustomerService";
import {
  AUTHORIZED_BUYER_EMAIL_REQUIRED,
  AUTHORIZED_BUYER_PHONE_REQUIRED,
  CHARACTERS_ALLOWED,
  CITY_REQUIRED,
  COUNTRY_REQUIRED,
  CUSTOMER_NAME_REQUIRED,
  CONTACTS_REQUIRED,
  EMAIL_VALIDATION,
  LENGTHS_ALLOWED,
  NUMBERS_ALLOWED,
  POSTALCODE_REQUIRED,
  PROVINCE_REQUIRED,
  SPECIAL_CHARACTERS_NOT_ALLOWED,
  STREET_REQUIRED,
  Street_PO_BOX_VALIDATION,
  emailRegex,
  letters,
  pattern,
  poBoxRegex,
  validateEditCustomerAddressFields,
  validateEditCustomerContactFields,
} from "./EditCustomerValidation";
import { IResponseMessage } from "../../Quotation/Quotation.types";
import { InitialStateOfResponseMessage } from "../../Quotation/Common/QuotationData";
import {
  SeparatorStyles,
  stackTokensWithGap10,
} from "../../Quotation/QuotationStyle";
import {
  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
  INVALID_PHONENUMBER,
  SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
  SPECIL_CHARACTER_INVALID_PHONENUMBER,
  allowCharactersAndSpecialSymbols,
  allowSpecialCharacterExcludingSome,
  numbersOnly,
  phoneNumberRegex,
  contactNumberRegex,
  taxIdPattern,
  uiTaxIdPattern,
  contactNameCharacterLimit,
  postalCodeCharacterLimit,
  POSTALCODE_CHARACTER_LIMIT,
  CONTACT_NAME_CHARACTER_LIMIT,
  companyTaxIdCharacterLimit,
  COMPANY_TAXID_CHARACTER_LIMIT,
  cityCharacterLimit,
  CITY_CHARACTER_LIMIT,
  CONTACT_LASTNAME_CHARACTER_LIMIT,
  CONTACT_FIRSTNAME_CHARACTER_LIMIT,
  EMAIL_CHARACTER_LIMIT,
  emailCharacterLimit,
} from "../AddNewCustomerAccount/AddCustomerValidation";
import { useLocalStorageContext } from "../../../Provider/LocalStorageProvider";
import { UserRoles } from "../../../common/enum/UserRoles";
import { CommonService } from "../../../services/Common/CommonService";

export const editAddressCustomerErrorIntialValue: ResponseAddress = {
  addressId: "",
  affilation: "",
  street: "",
  postalCode: "",
  city: "",
  province: "",
  country: "",
  name: "",
  registeredtaxId: "",
  customerCertifiedEmail: "",
  customerConsigneeCode: "",
  purchasingCompanyTaxId: "",
  shipmentCompanyTaxId: "",
  sapAccountId: "",
  contacts: {
    contactId: "",
    contactFirstName: "",
    contactLastName: "",
    contactPhone: "",
    contactEmail: "",
    isContactPrimary: "",
  },
  state: "",
  isAddressPrimary: "",
};

export const newAddressCustomerIntialValue: ResponseAddress = {
  addressId: "",
  affilation: "",
  street: "",
  postalCode: "",
  city: "",
  province: "",
  country: "",
  name: "",
  registeredtaxId: "",
  customerCertifiedEmail: "",
  customerConsigneeCode: "",
  purchasingCompanyTaxId: "",
  shipmentCompanyTaxId: "",
  sapAccountId: "",
  contacts: {
    contactId: "",
    contactFirstName: "",
    contactLastName: "",
    contactPhone: "",
    contactEmail: "",
    isContactPrimary: "",
  },
  state: "",
  isAddressPrimary: "",
};

const intialContactDefaultValue = [
  {
    customerAccountId: "",
    contactFirstName: "",
    contactLastName: "",
    contactPhone: "",
    contactEmail: "",
    id: "",
    partitionKey: "",
  },
];

const intialContactValue = {
  customerAccountId: "",
  contactFirstName: "",
  contactLastName: "",
  contactPhone: "",
  contactEmail: "",
  id: "",
  partitionKey: "",
};

const intialEditContactValue = {
  customerAccountId: "",
  contactFirstName: "",
  contactLastName: "",
  contactPhone: "",
  contactEmail: "",
  id: "",
  partitionKey: "",
};
const countryIntialValue = [
  {
    key: "",
    text: "",
    region: "",
  },
];

export interface ExtendedResponseAddress extends ResponseAddress {
  contacts_contactEmail?: string;
}

export const CustomerAddAddress: React.FunctionComponent<
  ICustomerEditAddressProps
> = (props) => {
  let selectedValue: ResponseAddress;
  let selectedContactValue: CustomerContact;
  const navigate = useNavigate();
  const location = useLocation();
  const { userRole } = useLocalStorageContext();
  const [customerNewAddress, setCustomerNewAddress] = useState<ResponseAddress>(
    newAddressCustomerIntialValue
  );
  const [customerEditAddress, setCustomerEditAddress] =
    useState<ResponseAddress>(newAddressIntialValue);
  const [isDeletedToggle, setisDeletedToggle] = useState(false);
  const [isNameChecked, setIsNameChecked] = useState(false);
  const [isFirstNameChecked, setIsFirstNameChecked] = useState(false);

  const [selectedGridData, setSelectedGridData] = React.useState<
    IObjectWithKey[] | undefined
  >(undefined);

  const [selectedContactsGridData, setSelectedContactsGridData] =
    React.useState<IObjectWithKey[] | undefined>(undefined);

  const [
    isShipOpen,
    { setTrue: openNewAddress, setFalse: dismissNewAddressPanel },
  ] = useBoolean(false);

  const [
    isContactOpen,
    { setTrue: openNewContact, setFalse: dismissNewContactPanel },
  ] = useBoolean(false);

  const [isContactPanelDisabled, setIsContactPanelDisabled] = useState(false);
  const customerAddAddressComboBoxStyle = {
    root: { width: 250 },
    callout: { width: "300px", height: "290px" },
  };

  const customerNewAccountComboBoxStyleAuto = {
    root: { width: 250 },
    callout: { width: "300px" },
  };

  const AddIcon: IIconProps = { iconName: "Add" };
  const EditIcon: IIconProps = { iconName: "Edit" };
  const ContactIcon: IIconProps = { iconName: "ContactCard" };
  const [isLoading, setIsLoading] = useState(false);

  const params = location && (location?.state as ResponseCustomerEditAccount);
  const { id, accountId, name } = params;

  const [editCustomer, setEditCustomer] = useState<ResponseCustomerEditAccount>(
    customerInfoIntialValue as ResponseCustomerEditAccount
  );

  useEffect(() => {
    CommonService.populateCountriesDetails()
      .then((res) => {
        if (res !== undefined) {
          setCountryOptions(res.data.data);
        }
      })
      .catch((error) => {
        console.log(
          "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" + error
        );
      });
  }, []);

  const [countryOptions, setCountryOptions] = useState(countryIntialValue);

  const [editCustomerAddressError, setEditCustomerAddressError] =
    useState<ResponseAddress>(newAddressIntialValue);

  const [customerAddressError, setCustomerAddressError] =
    useState<ResponseAddress>(customerErrorsIntialValue);

  const stackTokens: Partial<IStackTokens> = { childrenGap: 20 };
  const columnProps: Partial<IStackProps> = {
    tokens: { childrenGap: 5 },
    styles: { root: { width: 300, height: 150, marginRight: 10 } },
  };

  const { userRegions } = useLocalStorageContext();

  const [isDisabledNewAddress, setIsDisabledNewAddress] = useState(true);
  const [isDisabledEditAddress, setIsDisabledEditAddress] = useState(true);

  const [isNewAddressSelected, setIsNewAddressSelected] = useState(true);
  const [isEditAddressSelected, setIsEditAddressSelected] = useState(false);

  const [editAddressSuccessMessage, setEditAddressSuccessMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const [editAddressFailureMessage, setEditAddressFailureMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);

  const [editContactsSuccessMessage, setEditContactsSuccessMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const [editContactsFailureMessage, setEditContactsFailureMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);

  const [
    editSelectedContactsSuccessMessage,
    setEditSelectedContactsSuccessMessage,
  ] = useState<IResponseMessage>(InitialStateOfResponseMessage);
  const [
    editSelectedContactsFailureMessage,
    setEditSelectedContactsFailureMessage,
  ] = useState<IResponseMessage>(InitialStateOfResponseMessage);

  const [isEditModalButtonDisabled, setIsEditModalButtonDisabled] =
    useState(false);
  const [isAddModalButtonDisabled, setIsAddModalButtonDisabled] =
    useState(false);

  const [customerContactsError, setCustomerContactsError] =
    useState<CustomerContact>(intialContactValue);

  const [intialListOfContacts, setIntialListOfContacts] = useState(
    intialContactDefaultValue as CustomerContact[]
  );

  const [customerNewContact, setCustomerNewContact] =
    useState<CustomerContact>(intialContactValue);

  const [customerEditContact, setCustomerEditContact] =
    useState<CustomerContact>(intialEditContactValue);

  const [isCustomerDisabled, setIsCustomerDisabled] = useState(true);
  const [isCustomerButtonDisabled, setIsCustomerButtonDisabled] =
    useState(false);
  const [isCustomerEditButtonDisabled, setIsCustomerEditButtonDisabled] =
    useState(false);

  const [isContactsEditButtonDisabled, setIsContactsEditButtonDisabled] =
    useState(false);

  const [newAddressStateOptions, setnewAddressStateOptions] = useState([
    { key: "", text: "", country: "" },
  ]);

  const [editAddressStateOptions, setEditAddressStateOptions] = useState([
    { key: "", text: "", country: "" },
  ]);

  const gridList = editCustomer.addresses.filter(
    (x) => x.affilation === props.addressType
  );
  const regionWiseCountry =
    countryOptions &&
    countryOptions
      ?.filter((country) => userRegions.includes(country.region))
      .sort((a, b) => a.text.localeCompare(b.text));

  const [selectedBusinessSoldToCountry, setSelectedBusinessSoldToCountry] =
    useState(countryIntialValue);
  useEffect(() => {
    const filteredCountries =
      countryOptions &&
      countryOptions.filter((country) => country.key === editCustomer.country);
    setSelectedBusinessSoldToCountry(filteredCountries);
  }, [JSON.stringify(editCustomer)]);

  const selection = React.useMemo(
    () =>
      new Selection({
        onSelectionChanged: () => {
          setSelectedGridData(selection.getSelection());
        },
        selectionMode: SelectionMode.single,
      }),
    [selectedGridData]
  );

  const useScreenScale = () => {
    const [screenScale, setScreenScale] = useState(window.devicePixelRatio);

    useEffect(() => {
      const handleResize = () => {
        setScreenScale(window.devicePixelRatio);
      };

      // Attach the event listener to the window resize event
      window.addEventListener("resize", handleResize);

      // Clean up the event listener on component unmount
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []); // Empty dependency array ensures that the effect runs only once after mount

    return screenScale;
  };

  const screenScale = useScreenScale();

  let cardSize = {};
  if (screenScale === 1.5) {
    cardSize = { paddingLeft: 80, paddingRight: 180 };
  } else {
    cardSize = { paddingLeft: 80, paddingRight: 450 };
  }

  const customerSelection = React.useMemo(
    () =>
      new Selection({
        onSelectionChanged: () => {
          setSelectedContactsGridData(customerSelection.getSelection());
        },
        selectionMode: SelectionMode.single,
      }),
    [selectedContactsGridData]
  );

  const onRenderNewAddressFooter = () => {
    return (
      <Stack
        verticalFill
        verticalAlign="center"
        style={{ width: "100%", padding: 0, position: "relative" }}
      >
        <Separator styles={SeparatorStyles} />
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          <PrimaryButton
            text="Save"
            type="button"
            onClick={(e: any) => {
              addNewCustomerAddress(e);
            }}
            style={EditButtonStyle}
            disabled={isAddModalButtonDisabled}
          />
          <DefaultButton
            text="Cancel"
            type="button"
            onClick={() => {
              dismissNewAddressPanel();
              setCustomerNewAddress(newAddressCustomerIntialValue);
              setEditAddressFailureMessage(InitialStateOfResponseMessage);
            }}
            style={EditButtonStyle}
            disabled={isAddModalButtonDisabled}
          />
        </Stack>
      </Stack>
    );
  };
  const onRenderEditAddressFooter = () => {
    return (
      <Stack
        verticalFill
        verticalAlign="center"
        style={{ width: "100%", padding: 0 }}
      >
        <Separator styles={SeparatorStyles} />
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          <PrimaryButton
            text="Update"
            type="button"
            onClick={(e: any) => {
              editCustomerAddress(e);
            }}
            style={EditButtonStyle}
            disabled={isEditModalButtonDisabled}
          />
          <DefaultButton
            text="Cancel"
            type="button"
            onClick={() => {
              setCustomerAddressError(customerErrorsIntialValue);
              setEditAddressFailureMessage(InitialStateOfResponseMessage);
              dismissNewAddressPanel();
            }}
            style={EditButtonStyle}
            disabled={isEditModalButtonDisabled}
          />
        </Stack>
      </Stack>
    );
  };
  const onRenderNewContactFooter = () => {
    return (
      <Stack
        verticalFill
        verticalAlign="center"
        style={{ width: "100%", padding: 0 }}
      >
        <Separator styles={SeparatorStyles} />
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          <PrimaryButton
            text="Save"
            type="button"
            onClick={(e: any) => {
              addNewCustomerContactAddress(e);
            }}
            style={EditButtonStyle}
            disabled={isCustomerButtonDisabled}
          />
          <DefaultButton
            text="Cancel"
            type="button"
            onClick={() => {
              dismissNewContactPanel();
              setCustomerNewContact(intialContactValue);
              setEditContactsFailureMessage(InitialStateOfResponseMessage);
            }}
            style={EditButtonStyle}
            disabled={isCustomerButtonDisabled}
          />
        </Stack>
      </Stack>
    );
  };
  const onRenderEditContactFooter = () => {
    return (
      <Stack
        verticalFill
        verticalAlign="center"
        style={{ width: "100%", padding: 0 }}
      >
        <Separator styles={SeparatorStyles} />
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          <PrimaryButton
            text="Update"
            type="button"
            onClick={(e: any) => {
              editCustomerContactAddress(e);
            }}
            style={EditButtonStyle}
            disabled={isCustomerEditButtonDisabled}
          />
          <DefaultButton
            text="Cancel"
            type="button"
            onClick={() => {
              dismissNewContactPanel();
              setEditContactsFailureMessage(InitialStateOfResponseMessage);
            }}
            style={EditButtonStyle}
            disabled={isCustomerEditButtonDisabled}
          />
        </Stack>
      </Stack>
    );
  };

  function createErrorList(errorObject: any) {
    const errorList = [];

    // Iterate through the properties of the errorObject
    for (const key in errorObject) {
      if (errorObject.hasOwnProperty(key)) {
        const subErrors = errorObject[key];

        // Check if the property contains nested errors
        if (typeof subErrors === "object") {
          // Recursively call the function to get nested errors
          const nestedErrors: any = createErrorList(subErrors);

          // Add the nested errors to the list
          errorList.push(
            ...nestedErrors.map((error: any) => `${key}.${error}`)
          );
        } else {
          // If the property is a leaf node, add it to the list
          errorList.push(`${key}: ${errorObject[key]}`);
        }
      }
    }

    return errorList;
  }
  const newAddressErrorList = createErrorList(editCustomerAddressError);

  const editAddressErrorList = createErrorList(customerAddressError);

  const newAddressErrorMessage = Object.entries(newAddressErrorList)
    .filter(([key, value]) => value.trim().toLowerCase().includes("required"))
    .map(([key, value]) => `${key}: ${value}`);

  const editAddressErrorMessage = Object.entries(editAddressErrorList)
    .filter(([key, value]) => value.trim().toLowerCase().includes("required"))
    .map(([key, value]) => `${key}: ${value}`);

  const newAddressPanelHeight =
    newAddressErrorMessage.length > 3
      ? { height: "700px" }
      : { height: "580px" };

  const editAddressPanelHeight =
    editAddressErrorMessage.length > 3
      ? { height: "700px" }
      : { height: "580px" };

  useEffect(() => {
    props.onCustomerAccount(true);
  }, []);

  // Will use below code for API calls

  useEffect(() => {
    setEditAddressSuccessMessage(InitialStateOfResponseMessage);
    setEditAddressFailureMessage(InitialStateOfResponseMessage);
    setIsEditModalButtonDisabled(false);
    setIsAddModalButtonDisabled(false);
    setCustomerNewContact(intialContactValue);
    setCustomerNewAddress(newAddressCustomerIntialValue);
    if (id) {
      setIsLoading(true);
      CustomerService.getCustomerAccountsInfoById(id)
        .then((res) => {
          if (res !== undefined) {
            setEditCustomer(res.data.data.data);
            CustomerService.getCustomerContactById(id)
              .then((contacts) => {
                if (contacts !== undefined) {
                  setIntialListOfContacts(contacts?.data?.data);
                  setIsLoading(false);
                }
              })
              .catch((error) => {
                setIsLoading(false);
                console.log(
                  "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" +
                  error
                );
              });
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(
            "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" +
            error
          );
        });
    }
  }, []);

  useEffect(() => {
    setEditAddressSuccessMessage(InitialStateOfResponseMessage);
    setEditAddressFailureMessage(InitialStateOfResponseMessage);
    setIsCustomerEditButtonDisabled(false);
    setIsContactPanelDisabled(false);
    // setIsEditAddressSelected(true);
    setCustomerNewContact(intialContactValue);
    setCustomerNewAddress(newAddressCustomerIntialValue);
    setEditAddressFailureMessage({
      message: ``,
      showMessage: false,
    });
    if (editCustomer?.accountId?.length > 0) {
      if (isEditAddressSelected && isDisabledEditAddress) {
        setIsLoading(true);
      }
      CustomerService.updateCustomerAddress(editCustomer)
        .then((res) => {
          if (res?.data?.code == 200) {
            setEditAddressSuccessMessage({
              showMessage: true,
              message: `${props.addressType} updated succesfully`,
            });
            setTimeout(() => {
              if (!isDisabledEditAddress || !isDisabledEditAddress) {
                setIsLoading(true);
              }
              CustomerService.getCustomerAccountsInfoById(id)
                .then((res) => {
                  if (res !== undefined) {
                    setEditCustomer(customerInfoIntialValue);
                    setEditCustomer(res.data.data.data);
                    CustomerService.getCustomerContactById(id)
                      .then((contacts) => {
                        if (contacts !== undefined) {
                          setIntialListOfContacts(contacts?.data?.data);
                          setEditAddressSuccessMessage({
                            showMessage: false,
                            message: ``,
                          });
                          setIsDisabledEditAddress(true);
                          dismissNewAddressPanel();
                          setIsLoading(false);
                        }
                      })
                      .catch((error) => {
                        setIsLoading(false);
                        console.log(
                          "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" +
                          error
                        );
                      });
                  }
                })
                .catch((error) => {
                  setIsLoading(false);
                  console.log(
                    "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" +
                    error
                  );
                });
              setCustomerEditAddress(newAddressIntialValue);
              setCustomerNewAddress(newAddressCustomerIntialValue);
              setIsEditModalButtonDisabled(false);
              setIsAddModalButtonDisabled(false);
              setSelectedGridData(undefined);
              setSelectedContactsGridData(undefined);
            }, 3000);
          } else if (res?.data?.code == 400) {
            const dataMessage = res?.data?.message;
            setEditAddressFailureMessage({
              message: dataMessage?.split("\n").join(", "),
              showMessage: true,
            });
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(
            "Error in updateCustomerAccount CustomerAddAddress.tsx" + error
          );
          setCustomerEditAddress(newAddressIntialValue);
          setCustomerNewAddress(newAddressCustomerIntialValue);
          setIsEditModalButtonDisabled(false);
          setIsAddModalButtonDisabled(false);
        });
    }
  }, [isDeletedToggle]);

  useEffect(() => {
    if (selectedGridData === undefined) {
      setIsNewAddressSelected(true);
      setIsEditAddressSelected(false);
    } else {
      if (selectedGridData?.length > 0) {
        setIsEditAddressSelected(true);
        setIsNewAddressSelected(false);
      } else {
        setIsEditAddressSelected(false);
        setIsNewAddressSelected(true);
      }
    }
  }, [selectedGridData?.length]);

  useEffect(() => {
    if (selectedContactsGridData === undefined) {
      setIsCustomerDisabled(true);
      setIsContactsEditButtonDisabled(false);
    } else {
      if (selectedContactsGridData?.length > 0) {
        setIsCustomerDisabled(false);
      } else {
        setIsCustomerDisabled(true);
        setIsContactsEditButtonDisabled(false);
      }
      if (
        selectedContactsGridData?.length > 0 &&
        isCustomerDisabled === false
      ) {
        setIsContactsEditButtonDisabled(true);
      }
    }
  }, [selectedContactsGridData?.length]);

  const updatePrimaryAddressOnClick = async () => {
    setEditAddressSuccessMessage(InitialStateOfResponseMessage);
    setEditAddressFailureMessage(InitialStateOfResponseMessage);
    setIsCustomerEditButtonDisabled(false);
    setIsContactPanelDisabled(false);
    if (editCustomer?.accountId?.length > 0) {
      if (isEditAddressSelected && isDisabledEditAddress) {
        setIsLoading(true);
      }
      CustomerService.updateCustomerAccount(editCustomer)
        .then((res) => {
          if (res?.data?.code == 200) {
            setEditAddressSuccessMessage({
              showMessage: true,
              message: `${props.addressType} added succesfully`,
            });
            setTimeout(() => {
              if (isNewAddressSelected) {
                setIsLoading(true);
                setCustomerNewContact(intialContactValue);
                setCustomerNewAddress(newAddressCustomerIntialValue);
              }
              CustomerService.getCustomerAccountsInfoById(id)
                .then((res) => {
                  if (res !== undefined) {
                    setEditCustomer(customerInfoIntialValue);
                    setEditCustomer(res.data.data.data);
                    CustomerService.getCustomerContactById(id)
                      .then((contacts) => {
                        if (contacts !== undefined) {
                          setIntialListOfContacts(contacts?.data?.data);
                          setEditAddressSuccessMessage({
                            showMessage: false,
                            message: ``,
                          });
                          setIsDisabledNewAddress(true);
                          setIsDisabledEditAddress(true);
                          dismissNewAddressPanel();
                          setIsLoading(false);
                        }
                      })
                      .catch((error) => {
                        setIsLoading(false);
                        console.log(
                          "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" +
                          error
                        );
                      });
                  }
                })
                .catch((error) => {
                  setIsLoading(false);
                  console.log(
                    "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" +
                    error
                  );
                });
              setCustomerEditAddress(newAddressIntialValue);
              setCustomerNewAddress(newAddressCustomerIntialValue);
              setIsEditModalButtonDisabled(false);
              setIsAddModalButtonDisabled(false);
              setSelectedGridData(undefined);
              setSelectedContactsGridData(undefined);
            }, 3000);
          } else if (res?.data?.code == 400) {
            const dataMessage = res?.data?.message;
            setEditAddressFailureMessage({
              message: dataMessage?.split("\n").join(", "),
              showMessage: true,
            });
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(
            "Error in updateCustomerAccount CustomerAddAddress.tsx" + error
          );
          setCustomerEditAddress(newAddressIntialValue);
          setCustomerNewAddress(newAddressCustomerIntialValue);
          setIsEditModalButtonDisabled(false);
          setIsAddModalButtonDisabled(false);
        });
    }
  };

  if (isLoading || editCustomer === undefined) {
    return <Spinner size={SpinnerSize.large} />;
  }

  if (selectedGridData) {
    selectedValue = selectedGridData[0] as ResponseAddress;
  }

  if (selectedContactsGridData) {
    selectedContactValue = selectedContactsGridData[0] as CustomerContact;
  }

  const matchedAddressObject = (obj: any, matchedValue: any) => {
    // Compare each property for equality
    return (
      obj.name === matchedValue.name &&
      obj.affilation === matchedValue.affilation &&
      obj.street === matchedValue.street &&
      obj.postalCode === matchedValue.postalCode &&
      obj.city === matchedValue.city &&
      obj.state === matchedValue.state &&
      obj.country === matchedValue.country &&
      obj.purchasingCompanyTaxId === matchedValue.purchasingCompanyTaxId &&
      obj.shipmentCompanyTaxId === matchedValue.shipmentCompanyTaxId &&
      obj.sapAccountId === matchedValue.sapAccountId &&
      obj.contacts.contactId === matchedValue.contacts.contactId
    );
  };

  const _OnClickEditAccount = () => {
    const addressPanelStateList = countryWiseStateList.filter(
      (x) =>
        x.country.toLocaleLowerCase() ===
        selectedValue?.country?.toLocaleLowerCase()
    );
    setEditAddressStateOptions(addressPanelStateList);
    setCustomerEditAddress(selectedValue);
  };

  const addNewCustomerAddress = (e?: Event) => {
    e?.preventDefault();
    setEditCustomerAddressError(editAddressCustomerErrorIntialValue);
    customerNewAddress.affilation = props.addressType;
    const { isValidated, editCustomerAddressErrors: customerAddressErrors } =
      validateEditCustomerAddressFields(customerNewAddress);
    if (isValidated) {
      customerNewAddress.addressId = uuidv4();
      customerNewAddress.isAddressPrimary = "No";
      editCustomer.addresses.push(customerNewAddress);
      setEditCustomer(editCustomer);
      // setEditAddressSuccessMessage({
      //   showMessage: true,
      //   message: `${props.addressType} added succesfully`,
      // });
      setIsAddModalButtonDisabled(true);
      setTimeout(async () => {
        await updatePrimaryAddressOnClick();
        // dismissNewAddressPanel();
        setSelectedGridData(undefined);
      }, 3000);
    } else {
      setEditCustomerAddressError({ ...customerAddressErrors });
    }
  };

  const editCustomerAddress = (e?: Event) => {
    e?.preventDefault();
    setCustomerAddressError(customerErrorsIntialValue);
    const { isValidated, editCustomerAddressErrors } =
      validateEditCustomerAddressFields(customerEditAddress);
    if (isValidated) {
      const filteredAddressArray = editCustomer.addresses.filter((obj: any) =>
        matchedAddressObject(obj, customerEditAddress)
      );
      setEditAddressFailureMessage({
        showMessage: false,
        message: "",
      });

      if (filteredAddressArray.length == 0) {
        const newAddresses = editCustomer.addresses.map((selectedAddress) => {
          if (selectedAddress.addressId === selectedValue.addressId) {
            return {
              ...selectedAddress,
              addressId: customerEditAddress.addressId,
              affilation: customerEditAddress.affilation,
              name: customerEditAddress.name,
              street: customerEditAddress.street,
              postalCode: customerEditAddress.postalCode,
              city: customerEditAddress.city,
              state: customerEditAddress.state,
              country: customerEditAddress.country,
              purchasingCompanyTaxId:
                customerEditAddress.purchasingCompanyTaxId,
              shipmentCompanyTaxId: customerEditAddress.shipmentCompanyTaxId,
              sapAccountId: customerEditAddress.sapAccountId,
              isSelectedAddress: "true",
              contacts: {
                contactId: customerEditAddress.contacts?.contactId,
                contactFirstName:
                  customerEditAddress.contacts?.contactFirstName,
                contactLastName: customerEditAddress.contacts?.contactLastName,
                contactPhone: customerEditAddress.contacts?.contactPhone,
                contactEmail: customerEditAddress?.contacts?.contactEmail,
                isContactPrimary:
                  customerEditAddress?.contacts?.isContactPrimary,
              },
            };
          }

          return selectedAddress;
        });
        editCustomer.addresses = newAddresses;
        setEditCustomer(editCustomer);
        // setEditAddressSuccessMessage({
        //   showMessage: true,
        //   message: `${props.addressType} updated succesfully`,
        // });
        setIsEditModalButtonDisabled(true);
        setTimeout(() => {
          setisDeletedToggle(!isDeletedToggle);
          // dismissNewAddressPanel();
        }, 3000);
      } else {
        setEditAddressFailureMessage({
          showMessage: true,
          message: `${props.addressType} address already exist`,
        });
      }
    } else {
      setCustomerAddressError({ ...editCustomerAddressErrors });
    }
  };

  const hanldeSubmitClick = () => {
    navigate("/CustomerEditContact", { state: editCustomer });
  };

  const handlePrimaryAddressClick = async () => {
    const updatedPrimaryAddress = editCustomer.addresses.map((address) => {
      if (
        address.addressId === selectedValue.addressId &&
        address.affilation === props.addressType
      ) {
        // Modify the properties of the target object
        return {
          ...address,
          isAddressPrimary: "Yes",
        };
      } else if (
        address.addressId !== selectedValue.addressId &&
        address.affilation === props.addressType
      ) {
        return {
          ...address,
          isAddressPrimary: "No",
        };
      }
      return address;
    });

    editCustomer.addresses = updatedPrimaryAddress;
    await updatePrimaryAddressOnClick();
  };

  const addCustomerContactstData = async (
    editCustomerContacts: CustomerContact
  ) => {
    setEditContactsFailureMessage({
      message: ``,
      showMessage: false,
    });
    await CustomerService.addCustomerContact(
      editCustomerContacts as CustomerContact
    )
      .then((res) => {
        if (res !== undefined) {
          if (res.data.code !== 400) {
            setEditContactsSuccessMessage({
              showMessage: true,
              message: `Contacts added succesfully`,
            });
          }
          setTimeout(() => {
            dismissNewAddressPanel();
            setIsLoading(true);
            setisDeletedToggle(!isDeletedToggle);
            setCustomerNewContact(intialContactValue);
            setIsContactPanelDisabled(false);
            setEditContactsSuccessMessage(InitialStateOfResponseMessage);
            setIsCustomerButtonDisabled(false);
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(
          "Error in UpdateCustomerInfo API in CustomerEditContact.tsx" + error
        );
      });
  };

  const updateCustomerContactstData = async (
    editCustomerContacts: CustomerContact
  ) => {
    setEditSelectedContactsFailureMessage({
      message: ``,
      showMessage: false,
    });
    await CustomerService.updateCustomerContact(
      editCustomerContacts as CustomerContact
    )
      .then((res) => {
        if (res !== undefined) {
          if (res.data.code !== 400) {
            setEditSelectedContactsSuccessMessage({
              showMessage: true,
              message: `Contacts updated succesfully`,
            });
          }
          setTimeout(() => {
            dismissNewAddressPanel();
            setIsLoading(true);
            setisDeletedToggle(!isDeletedToggle);
            setCustomerEditContact(intialEditContactValue);
            setIsContactsEditButtonDisabled(false);
            setEditSelectedContactsSuccessMessage(
              InitialStateOfResponseMessage
            );
            setIsCustomerButtonDisabled(false);
            setIsCustomerDisabled(false);
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(
          "Error in UpdateCustomerInfo API in CustomerEditContact.tsx" + error
        );
      });
  };

  const primaryAddressContactId = editCustomer.addresses.find(
    (x) =>
      x.affilation.toLocaleLowerCase() ===
      props.addressType.toLocaleLowerCase() &&
      x.isAddressPrimary?.toLocaleLowerCase() === "yes"
  )?.contacts?.contactId;

  const filterUniqueObjectsByProperties = (
    contactsArray: any,
    properties: any[]
  ) => {
    const seenValues = new Set();
    return contactsArray.filter((obj: any) => {
      const key = properties.map((prop) => obj[prop].toLowerCase()).join("|");
      if (!seenValues.has(key)) {
        seenValues.add(key);
        return true;
      }
      return false;
    });
  };

  const updatedPrimaryContactsIntial: any = intialListOfContacts
    .map((contacts) => {
      if (contacts.id === primaryAddressContactId) {
        return {
          ...contacts,
          isContactPrimary: "Yes",
        };
      } else {
        return {
          ...contacts,
          isContactPrimary: "No",
        };
      }
    })
    .sort((a, b) => {
      if (a.isContactPrimary === "Yes" && b.isContactPrimary === "No") {
        return -1;
      } else if (a.isContactPrimary === "No" && b.isContactPrimary === "Yes") {
        return 1;
      } else {
        return 0;
      }
    });

  const updatedPrimaryContacts: any = filterUniqueObjectsByProperties(
    updatedPrimaryContactsIntial,
    ["contactFirstName", "contactLastName", "contactPhone", "contactEmail"]
  )
    .filter((x: { contactEmail: string }) => x.contactEmail !== "")
    .sort((a: any, b: any) =>
      a.contactFirstName.localeCompare(b.contactFirstName)
    );

  const contactListKeyValuePair: IComboBoxOption[] = updatedPrimaryContacts.map(
    ({ id, contactEmail, contactPhone }: any) => ({
      key: id,
      text: `${contactEmail}, ${contactPhone}`,
    })
  );

  const onClickEditContact = () => {
    setCustomerContactsError(intialContactValue);
    setCustomerEditContact(selectedContactValue);
    setEditSelectedContactsSuccessMessage(InitialStateOfResponseMessage);
    setEditSelectedContactsFailureMessage(InitialStateOfResponseMessage);
    setIsContactsEditButtonDisabled(true);
  };

  const transformedData = gridList
    .map((address) => ({
      ...address,
      contacts_contactEmail: address.contacts.contactEmail,
    }))
    .sort((a, b) => a.street.localeCompare(b.street));

  function filterObjects(obj: any, matchedValue: any) {
    // Compare each property for equality
    return (
      obj.contactFirstName === matchedValue.contactFirstName &&
      obj.contactLastName === matchedValue.contactLastName &&
      obj.contactPhone === matchedValue.contactPhone &&
      obj.contactEmail === matchedValue.contactEmail
    );
  }

  const editCustomerContactAddress = (e?: Event) => {
    e?.preventDefault();
    //setIsCustomerEditButtonDisabled(false);
    setIsCustomerEditButtonDisabled(true);
    const { isValidated, editRegisteredContactErrors } =
      validateEditCustomerContactFields(customerEditContact);
    if (isValidated) {
      const filteredArray = updatedPrimaryContacts.filter((obj: any) =>
        filterObjects(obj, customerEditContact)
      );
      if (filteredArray.length > 0) {
        setEditSelectedContactsFailureMessage({
          message: `Customer contact already exist`,
          showMessage: true,
        });
        setIsCustomerEditButtonDisabled(false);
      } else {
        setEditSelectedContactsSuccessMessage({
          showMessage: true,
          message: `Contacts updated succesfully`,
        });
        updateCustomerContactstData(customerEditContact);
      }
    } else {
      setIsCustomerEditButtonDisabled(false);
      setCustomerContactsError({ ...editRegisteredContactErrors });
    }
  };

  const addNewCustomerContactAddress = (e?: Event) => {
    e?.preventDefault();
    setCustomerContactsError(intialContactValue);
    const { isValidated, editRegisteredContactErrors } =
      validateEditCustomerContactFields(customerNewContact);
    if (isValidated) {
      const filteredArray = updatedPrimaryContacts.filter((obj: any) =>
        filterObjects(obj, customerNewContact)
      );
      if (filteredArray.length > 0) {
        setEditContactsFailureMessage({
          message: `Customer contact already exist`,
          showMessage: true,
        });
      } else {
        setIsCustomerButtonDisabled(true);
        // setIsAddModalButtonDisabled(true);
        customerNewContact.customerAccountId = editCustomer.id;
        addCustomerContactstData(customerNewContact);
      }
    } else {
      setCustomerContactsError({ ...editRegisteredContactErrors });
    }
  };

  return (
    <Stack verticalAlign="start" tokens={stackTokensWithGap10}>
      <Stack
        data-testid="customer-account-page"
        style={{
          marginTop: "10px",
          height: 330,
          background: "white",
          marginLeft: "20px",
        }}
      >
        <div
          style={{
            alignItems: "flex-end",
          }}
        >
          <ActionButton
            iconProps={ContactIcon}
            disabled={
              userRole === UserRoles.GTFS || isCustomerDisabled === false
                ? true
                : !isEditAddressSelected
            }
            onClick={() => {
              setEditCustomerAddressError(editAddressCustomerErrorIntialValue);
              handlePrimaryAddressClick();
            }}
          >
            Make Primary
          </ActionButton>
          <ActionButton
            iconProps={AddIcon}
            disabled={
              userRole === UserRoles.GTFS || isCustomerDisabled === false
                ? true
                : !isNewAddressSelected
            }
            onClick={() => {
              setEditCustomerAddressError(editAddressCustomerErrorIntialValue);
              setIsDisabledEditAddress(true);
              setIsDisabledNewAddress(false);
              openNewAddress();
              setnewAddressStateOptions([{ key: "", text: "", country: "" }]);
            }}
          >
            Add
          </ActionButton>
          <ActionButton
            iconProps={EditIcon}
            disabled={
              isCustomerDisabled === false ? true : !isEditAddressSelected
            }
            onClick={() => {
              setCustomerAddressError(customerErrorsIntialValue);
              setIsEditAddressSelected(true);
              setIsNewAddressSelected(false);
              setIsDisabledEditAddress(false);
              setIsDisabledNewAddress(true);
              openNewAddress();
              _OnClickEditAccount();
            }}
          >
            Edit
          </ActionButton>
        </div>
        <CoherenceDataGrid
          ariaLabelForSelectAllCheckbox="select all checkbox"
          checkButtonAriaLabel="checkbox"
          compactMode="compact"
          selection={selection}
          selectionMode={SelectionMode.single}
          selectionPreservedOnEmptyClick
          setKey="DATA_GRID_SORTABLE_SELECTABLE"
          data={transformedData as ExtendedResponseAddress[]}
          isScrollable
          isSortable
          listConfig={[
            {
              fieldName: "street",
              isResizable: true,
              key: "address",
              name: "Address",
              type: "string",
            },
            {
              fieldName: "name",
              isResizable: true,
              key: "Name",
              name: "Name",
              type: "string",
            },
            {
              fieldName: "postalCode",
              isResizable: true,
              key: "Zip/Postal Code",
              name: "Zip/Postal Code",
              type: "string",
            },
            {
              fieldName: "contacts_contactEmail",
              isResizable: true,
              key: "contacts_contactEmaill",
              name: "Primary Contact",
              type: "string",
            },
            {
              fieldName: "country",
              isResizable: true,
              key: "Country",
              name: "Country",
              type: "string",
            },
            {
              fieldName: "isAddressPrimary",
              isResizable: true,
              key: "Primary",
              name: "Primary",
              type: "string",
            },
          ]}
        />
        {!isDisabledNewAddress && (
          <div>
            <CoherencePanel
              panelSize="450px"
              headerText="New Address"
              titleText="New Address"
              isOpen={isShipOpen}
              onDismiss={dismissNewAddressPanel}
              onRenderFooter={onRenderNewAddressFooter}
              onRenderFooterContent={onRenderNewAddressFooter}
              // You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
              closeButtonAriaLabel="Close"
            >
              <div>
                {editAddressSuccessMessage.showMessage && (
                  <MessageBar
                    messageBarType={MessageBarType.success}
                    onDismiss={() =>
                      setEditAddressSuccessMessage(
                        InitialStateOfResponseMessage
                      )
                    }
                  >
                    {editAddressSuccessMessage.message}
                  </MessageBar>
                )}
                {editAddressFailureMessage.showMessage && (
                  <MessageBar
                    messageBarType={MessageBarType.error}
                    onDismiss={() =>
                      setEditAddressFailureMessage(
                        InitialStateOfResponseMessage
                      )
                    }
                  >
                    {editAddressFailureMessage.message}
                  </MessageBar>
                )}
              </div>
              <form style={newAddressPanelHeight}>
                <Stack verticalAlign="space-evenly" tokens={stackTokens}>
                  <Stack {...columnProps}>
                    <Stack
                      verticalAlign="start"
                      style={{
                        display: "-webkit-inline-box",
                        flexDirection: "row",
                      }}
                    >
                      {" "}
                      <TextField
                        styles={MediumTextFieldStyles}
                        label="Name"
                        name="name"
                        required
                        value={customerNewAddress.name}
                        onChange={(e, nameValue) => {
                          if (nameValue && nameValue?.length > 0) {
                            var specialCharacterCustomerName =
                              allowSpecialCharacterExcludingSome.test(
                                nameValue
                              );
                            if (specialCharacterCustomerName) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                name: "",
                              });
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              name: CUSTOMER_NAME_REQUIRED,
                            });
                          }
                          setCustomerNewAddress({
                            ...customerNewAddress,
                            name: nameValue ?? "",
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerNewAddress?.name &&
                            customerNewAddress.name?.length > 0
                          ) {
                            var specialCharacterCustomerName =
                              allowSpecialCharacterExcludingSome.test(
                                customerNewAddress.name
                              );
                            if (customerNewAddress?.name?.length > contactNameCharacterLimit) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                name: CONTACT_NAME_CHARACTER_LIMIT,
                              });
                            }
                            else if (specialCharacterCustomerName) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                name: "",
                              });
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              name: CUSTOMER_NAME_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={editCustomerAddressError?.name}
                      />
                    </Stack>
                    <Stack>
                      <TextField
                        label="Street (Must not be P.O. Box)"
                        styles={MediumTextFieldStyles}
                        value={customerNewAddress.street}
                        required
                        onChange={(e, streetValue) => {
                          const addCustomerFormData = {
                            ...customerNewAddress,
                            street: streetValue ?? "",
                          };
                          if (streetValue && streetValue?.length > 0) {
                            var streetLength = streetValue.length;
                            var poBoxRegexSpecialCharacterStreetPattern =
                              allowSpecialCharacterExcludingSome.test(
                                streetValue
                              );
                            if (streetLength <= 60) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                street: "",
                              });
                              if (poBoxRegexSpecialCharacterStreetPattern) {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  street: "",
                                });
                              } else {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  street: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                street:
                                  "Street Length should not be greater than 60 characters",
                              });
                            }
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              street: STREET_REQUIRED,
                            });
                          }
                          setCustomerNewAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerNewAddress.street &&
                            customerNewAddress.street?.length > 0
                          ) {
                            var streetLength = customerNewAddress.street.length;
                            var poBoxRegexStreetPattern = poBoxRegex.test(
                              customerNewAddress.street
                            );
                            var poBoxRegexSpecialCharacterStreetPattern =
                              allowSpecialCharacterExcludingSome.test(
                                customerNewAddress.street
                              );
                            if (streetLength <= 60) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                street: "",
                              });
                              if (poBoxRegexSpecialCharacterStreetPattern) {
                                if (poBoxRegexStreetPattern) {
                                  setEditCustomerAddressError({
                                    ...editCustomerAddressError,
                                    street: Street_PO_BOX_VALIDATION,
                                  });
                                } else {
                                  setEditCustomerAddressError({
                                    ...editCustomerAddressError,
                                    street: "",
                                  });
                                }
                              } else {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  street: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                street:
                                  "Street Length should not be greater than 60 characters",
                              });
                            }
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              street: STREET_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={editCustomerAddressError?.street}
                      />
                      <TextField
                        label="Zip/Postal Code"
                        styles={MediumTextFieldStyles}
                        required
                        value={customerNewAddress.postalCode}
                        onChange={(e, postalValue) => {
                          if (postalValue && postalValue?.length > 0) {
                            var specialCharacterCustomerPostalCode =
                              allowSpecialCharacterExcludingSome.test(
                                postalValue
                              );
                            if (specialCharacterCustomerPostalCode) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                postalCode: "",
                              });
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                postalCode: SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              postalCode: POSTALCODE_REQUIRED,
                            });
                          }
                          const addCustomerFormData = {
                            ...customerNewAddress,
                            postalCode: postalValue ?? "",
                          };
                          setCustomerNewAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerNewAddress.postalCode &&
                            customerNewAddress.postalCode?.length > 0
                          ) {
                            var specialCharacterCustomerPostalCode =
                              allowSpecialCharacterExcludingSome.test(
                                customerNewAddress.postalCode
                              );
                            if (customerNewAddress.postalCode?.length > postalCodeCharacterLimit) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                postalCode: POSTALCODE_CHARACTER_LIMIT,
                              });
                            }
                            else if (specialCharacterCustomerPostalCode) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                postalCode: "",
                              });
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                postalCode: SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              postalCode: POSTALCODE_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={editCustomerAddressError?.postalCode}
                      />

                      {props.addressType.toLocaleLowerCase() === "billing" && (
                        <TextField
                          label="Purchasing Company Tax ID"
                          styles={
                            userRole === UserRoles.GTFS
                              ? DisabledMediumTextFieldStyles
                              : MediumTextFieldStyles
                          }
                          readOnly={userRole === UserRoles.GTFS}
                          value={customerNewAddress?.purchasingCompanyTaxId}
                          onChange={(e, purchasingValue) => {
                            if (
                              purchasingValue &&
                              purchasingValue?.length > 0
                            ) {
                              var specialCharacterCustomerPurchasingId =
                                allowSpecialCharacterExcludingSome.test(
                                  purchasingValue
                                );
                              if (specialCharacterCustomerPurchasingId) {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  purchasingCompanyTaxId: "",
                                });
                              } else {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  purchasingCompanyTaxId:
                                    SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                purchasingCompanyTaxId: "",
                              });
                            }
                            const addCustomerFormData = {
                              ...customerNewAddress,
                              purchasingCompanyTaxId:
                                purchasingValue?.toLocaleLowerCase() === "n/a"
                                  ? "N/A"
                                  : purchasingValue || "",
                            };

                            setCustomerNewAddress(addCustomerFormData);
                          }}
                          onBlur={() => {
                            if (
                              customerNewAddress?.purchasingCompanyTaxId &&
                              customerNewAddress?.purchasingCompanyTaxId
                                ?.length > 0
                            ) {
                              var specialCharacterCustomerPurchasingId =
                                allowSpecialCharacterExcludingSome.test(
                                  customerNewAddress?.purchasingCompanyTaxId
                                );
                              if (customerNewAddress?.purchasingCompanyTaxId?.length > companyTaxIdCharacterLimit) {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  purchasingCompanyTaxId: COMPANY_TAXID_CHARACTER_LIMIT,
                                });
                              }

                              else if (specialCharacterCustomerPurchasingId) {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  purchasingCompanyTaxId: "",
                                });
                              } else {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  purchasingCompanyTaxId:
                                    SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                purchasingCompanyTaxId: "",
                              });
                            }
                          }}
                          errorMessage={
                            editCustomerAddressError?.purchasingCompanyTaxId
                          }
                        />
                      )}
                      {props.addressType.toLocaleLowerCase() === "shipping" && (
                        <TextField
                          label="Shipment Company Tax ID"
                          styles={
                            userRole === UserRoles.GTFS
                              ? DisabledMediumTextFieldStyles
                              : MediumTextFieldStyles
                          }
                          readOnly={userRole === UserRoles.GTFS}
                          value={customerNewAddress?.shipmentCompanyTaxId}
                          onChange={(e, shippingIdValue) => {
                            if (
                              shippingIdValue &&
                              shippingIdValue?.length > 0
                            ) {
                              var specialCharacterCustomerShipmentId =
                                allowSpecialCharacterExcludingSome.test(
                                  shippingIdValue
                                );
                              if (specialCharacterCustomerShipmentId) {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  shipmentCompanyTaxId: "",
                                });
                              } else {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  shipmentCompanyTaxId:
                                    SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                shipmentCompanyTaxId: "",
                              });
                            }
                            const addCustomerFormData = {
                              ...customerNewAddress,
                              shipmentCompanyTaxId:
                                shippingIdValue?.toLocaleLowerCase() === "n/a"
                                  ? "N/A"
                                  : shippingIdValue || "",
                            };

                            setCustomerNewAddress(addCustomerFormData);
                          }}
                          onBlur={() => {
                            if (
                              customerNewAddress?.shipmentCompanyTaxId &&
                              customerNewAddress?.shipmentCompanyTaxId?.length > 0
                            ) {
                              var specialCharacterCustomerShipmentId =
                                allowSpecialCharacterExcludingSome.test(
                                  customerNewAddress?.shipmentCompanyTaxId
                                );
                              if (customerNewAddress?.shipmentCompanyTaxId?.length > companyTaxIdCharacterLimit) {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  shipmentCompanyTaxId: COMPANY_TAXID_CHARACTER_LIMIT,
                                });
                              }
                              else if (specialCharacterCustomerShipmentId) {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  shipmentCompanyTaxId: "",
                                });
                              } else {
                                setEditCustomerAddressError({
                                  ...editCustomerAddressError,
                                  shipmentCompanyTaxId:
                                    SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                shipmentCompanyTaxId: "",
                              });
                            }
                          }}
                          errorMessage={
                            editCustomerAddressError?.shipmentCompanyTaxId
                          }
                        />
                      )}
                      <TextField
                        label={
                          props.addressType.toLocaleLowerCase() === "shipping"
                            ? "Ship To SAP Account ID"
                            : "Bill To SAP Account ID"
                        }
                        styles={MediumTextFieldStyles}
                        value={customerNewAddress?.sapAccountId}
                        onChange={(e, sapAccountIdValue) => {
                          if (
                            sapAccountIdValue &&
                            sapAccountIdValue?.length > 0
                          ) {
                            var specialCharacterCustomerPurchasingId =
                              numbersOnly.test(sapAccountIdValue);
                            if (specialCharacterCustomerPurchasingId) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                sapAccountId: "",
                              });
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                sapAccountId: NUMBERS_ALLOWED,
                              });
                            }
                          }
                          const addCustomerFormData = {
                            ...customerNewAddress,
                            sapAccountId: sapAccountIdValue ?? "",
                          };
                          setCustomerNewAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerNewAddress?.sapAccountId &&
                            customerNewAddress?.sapAccountId?.length > 0
                          ) {
                            var specialCharacterCustomerPurchasingId =
                              numbersOnly.test(
                                customerNewAddress?.sapAccountId
                              );
                            if (specialCharacterCustomerPurchasingId) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                sapAccountId: "",
                              });
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                sapAccountId: NUMBERS_ALLOWED,
                              });
                            }
                          }
                        }}
                        errorMessage={editCustomerAddressError?.sapAccountId}
                      />
                      <TextField
                        label="City"
                        styles={MediumTextFieldStyles}
                        required
                        value={customerNewAddress.city}
                        onChange={(e, cityValue) => {
                          if (cityValue && cityValue?.length > 0) {
                            var characterCustomerCity =
                              allowSpecialCharacterExcludingSome.test(
                                cityValue
                              );
                            if (characterCustomerCity) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                city: "",
                              });
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              city: CITY_REQUIRED,
                            });
                          }
                          const addCustomerFormData = {
                            ...customerNewAddress,
                            city: cityValue ?? "",
                          };
                          setCustomerNewAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerNewAddress.city &&
                            customerNewAddress.city?.length > 0
                          ) {
                            var characterCustomerCity =
                              allowSpecialCharacterExcludingSome.test(
                                customerNewAddress.city
                              );
                            if (customerNewAddress.city?.length > cityCharacterLimit) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                city: CITY_CHARACTER_LIMIT,
                              });
                            }
                            else if (characterCustomerCity) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                city: "",
                              });
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              city: CITY_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={editCustomerAddressError?.city}
                      />
                      <ComboBox
                        styles={customerNewAccountComboBoxStyleAuto}
                        label="Country"
                        options={selectedBusinessSoldToCountry}
                        required
                        selectedKey={customerNewAddress?.country}
                        onChange={(e, countryValue) => {
                          const addCustomerFormData = {
                            ...customerNewAddress,
                            country: countryValue?.text.toString() ?? "",
                          };
                          setEditCustomerAddressError({
                            ...editCustomerAddressError,
                            country: "",
                          });
                          setCustomerNewAddress(addCustomerFormData);
                          const billingAddressStateList = countryWiseStateList
                            .filter(
                              (x) =>
                                x.country.toLocaleLowerCase() ===
                                countryValue?.text.toLocaleLowerCase()
                            )
                            .sort((a, b) => a.text.localeCompare(b.text));
                          setnewAddressStateOptions(billingAddressStateList);
                        }}
                        onBlur={() => {
                          if (
                            customerNewAddress?.country &&
                            customerNewAddress?.country?.length > 0
                          ) {
                            var characterCustomerCountry = letters.test(
                              customerNewAddress?.country?.toString()
                            );
                            if (characterCustomerCountry) {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                country: "",
                              });
                            } else {
                              setEditCustomerAddressError({
                                ...editCustomerAddressError,
                                country: CHARACTERS_ALLOWED,
                              });
                            }
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              country: COUNTRY_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={editCustomerAddressError?.country}
                      />
                      <ComboBox
                        styles={customerAddAddressComboBoxStyle}
                        label="State/Province"
                        options={newAddressStateOptions}
                        required
                        selectedKey={customerNewAddress.state}
                        onChange={(e, provinceValue) => {
                          const addCustomerFormData = {
                            ...customerNewAddress,
                            state: provinceValue?.text.toString() ?? "",
                          };
                          setEditCustomerAddressError({
                            ...editCustomerAddressError,
                            state: " ",
                          });
                          setCustomerNewAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerNewAddress?.state &&
                            customerNewAddress?.state?.length > 0
                          ) {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              state: " ",
                            });
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              state: PROVINCE_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={editCustomerAddressError?.state}
                      />

                      <ComboBox
                        label="Contacts"
                        placeholder="Select Contacts"
                        styles={customerAddAddressComboBoxStyle}
                        options={contactListKeyValuePair}
                        required
                        //selectedKey={customerNewAddress.contacts.contactId}
                        onChange={(e, contactValue) => {
                          if (contactValue && contactValue?.text.length > 0) {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              contacts: {
                                ...editCustomerAddressError.contacts,
                                contactId: "",
                              },
                            });
                          } else {
                            setEditCustomerAddressError({
                              ...editCustomerAddressError,
                              contacts: {
                                ...editCustomerAddressError.contacts,
                                contactId: CONTACTS_REQUIRED,
                              },
                            });
                          }
                          const addCustomerFormData = {
                            ...customerNewAddress,
                            contacts: {
                              ...customerNewAddress.contacts,
                              contactId: contactValue?.key.toString() || "",
                            },
                          };
                          setCustomerNewAddress(addCustomerFormData);
                        }}
                        errorMessage={editCustomerAddressError?.contacts.contactId.toString()}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              </form>
            </CoherencePanel>
          </div>
        )}
        {!isDisabledEditAddress && (
          <div>
            <CoherencePanel
              panelSize="450px"
              headerText="Edit Address"
              titleText="Edit Address"
              isOpen={isShipOpen}
              onDismiss={dismissNewAddressPanel}
              onRenderFooter={onRenderEditAddressFooter}
              onRenderFooterContent={onRenderEditAddressFooter}
              // You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
              closeButtonAriaLabel="Close"
            >
              <div>
                {editAddressSuccessMessage.showMessage && (
                  <MessageBar
                    messageBarType={MessageBarType.success}
                    onDismiss={() =>
                      setEditAddressSuccessMessage(
                        InitialStateOfResponseMessage
                      )
                    }
                  >
                    {editAddressSuccessMessage.message}
                  </MessageBar>
                )}
                {editAddressFailureMessage.showMessage && (
                  <MessageBar
                    messageBarType={MessageBarType.error}
                    onDismiss={() =>
                      setEditAddressFailureMessage(
                        InitialStateOfResponseMessage
                      )
                    }
                  >
                    {editAddressFailureMessage.message}
                  </MessageBar>
                )}
              </div>
              <form style={editAddressPanelHeight}>
                <Stack verticalAlign="space-evenly" tokens={stackTokens}>
                  <Stack {...columnProps}>
                    <Stack>
                      <TextField
                        label="Name"
                        name="name"
                        styles={
                          userRole === UserRoles.GTFS
                            ? DisabledMediumTextFieldStyles
                            : MediumTextFieldStyles
                        }
                        readOnly={userRole === UserRoles.GTFS}
                        required
                        value={customerEditAddress?.name}
                        onChange={(e, nameValue) => {
                          if (nameValue && nameValue?.length > 0) {
                            var specialCharacterCustomerName =
                              allowSpecialCharacterExcludingSome.test(
                                nameValue
                              );
                            if (specialCharacterCustomerName) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                name: "",
                              });
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              name: CUSTOMER_NAME_REQUIRED,
                            });
                          }
                          const addCustomerFormData = {
                            ...customerEditAddress,
                            name: nameValue ?? "",
                          };

                          setCustomerEditAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerEditAddress?.name &&
                            customerEditAddress?.name?.length > 0
                          ) {
                            var specialCharacterCustomerName =
                              allowSpecialCharacterExcludingSome.test(
                                customerEditAddress?.name
                              );
                            if (customerEditAddress?.name?.length > contactNameCharacterLimit) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                name: CONTACT_NAME_CHARACTER_LIMIT,
                              });
                            }
                            else if (specialCharacterCustomerName) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                name: "",
                              });
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              name: CUSTOMER_NAME_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={customerAddressError?.name}
                      />
                      <TextField
                        label="Street (Must not be P.O. Box)"
                        styles={
                          userRole === UserRoles.GTFS
                            ? DisabledMediumTextFieldStyles
                            : MediumTextFieldStyles
                        }
                        readOnly={userRole === UserRoles.GTFS}
                        value={customerEditAddress?.street}
                        required
                        onChange={(e, streetValue) => {
                          if (streetValue && streetValue?.length > 0) {
                            var streetLength = streetValue.length;
                            var poBoxRegexSpecialCharacterStreetPattern =
                              allowSpecialCharacterExcludingSome.test(
                                streetValue
                              );
                            if (streetLength <= 60) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                street: "",
                              });
                              if (poBoxRegexSpecialCharacterStreetPattern) {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  street: "",
                                });
                              } else {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  street: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                street:
                                  "Street Length should not be greater than 60 characters",
                              });
                            }
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              street: STREET_REQUIRED,
                            });
                          }
                          const addCustomerFormData = {
                            ...customerEditAddress,
                            street: streetValue ?? "",
                          };
                          setCustomerEditAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerEditAddress?.street &&
                            customerEditAddress?.street?.length > 0
                          ) {
                            var streetLength =
                              customerEditAddress?.street.length;
                            var poBoxRegexStreetPattern = poBoxRegex.test(
                              customerEditAddress?.street
                            );
                            var poBoxRegexSpecialCharacterStreetPattern =
                              allowSpecialCharacterExcludingSome.test(
                                customerEditAddress?.street
                              );
                            if (streetLength <= 60) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                street: "",
                              });
                              if (poBoxRegexSpecialCharacterStreetPattern) {
                                if (poBoxRegexStreetPattern) {
                                  setCustomerAddressError({
                                    ...customerAddressError,
                                    street: Street_PO_BOX_VALIDATION,
                                  });
                                } else {
                                  setCustomerAddressError({
                                    ...customerAddressError,
                                    street: "",
                                  });
                                }
                              } else {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  street: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                street:
                                  "Street Length should not be greater than 60 characters",
                              });
                            }
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              street: STREET_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={customerAddressError?.street}
                      />
                      <TextField
                        label="Zip/Postal Code"
                        styles={
                          userRole === UserRoles.GTFS
                            ? DisabledMediumTextFieldStyles
                            : MediumTextFieldStyles
                        }
                        readOnly={userRole === UserRoles.GTFS}
                        required
                        value={customerEditAddress?.postalCode}
                        onChange={(e, postalValue) => {
                          if (postalValue && postalValue?.length > 0) {
                            var specialCharacterCustomerPostalCode =
                              allowSpecialCharacterExcludingSome.test(
                                postalValue
                              );

                            if (specialCharacterCustomerPostalCode) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                postalCode: "",
                              });
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                postalCode: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              postalCode: POSTALCODE_REQUIRED,
                            });
                          }
                          const addCustomerFormData = {
                            ...customerEditAddress,
                            postalCode: postalValue ?? "",
                          };
                          setCustomerEditAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerEditAddress?.postalCode &&
                            customerEditAddress?.postalCode?.length > 0
                          ) {
                            var specialCharacterCustomerPostalCode =
                              allowSpecialCharacterExcludingSome.test(
                                customerEditAddress?.postalCode
                              );
                            if (customerEditAddress?.postalCode?.length > postalCodeCharacterLimit) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                postalCode: POSTALCODE_CHARACTER_LIMIT,
                              });
                            }
                            else if (specialCharacterCustomerPostalCode) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                postalCode: "",
                              });
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                postalCode: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              postalCode: POSTALCODE_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={customerAddressError?.postalCode}
                      />

                      {props.addressType.toLocaleLowerCase() === "billing" && (
                        <TextField
                          label="Purchasing Company Tax ID"
                          styles={
                            userRole === UserRoles.GTFS
                              ? DisabledMediumTextFieldStyles
                              : MediumTextFieldStyles
                          }
                          readOnly={userRole === UserRoles.GTFS}
                          value={customerEditAddress?.purchasingCompanyTaxId}
                          onChange={(e, purchasingValue) => {
                            if (
                              purchasingValue &&
                              purchasingValue?.length > 0
                            ) {
                              var specialCharacterCustomerPurchasingId =
                                allowSpecialCharacterExcludingSome.test(
                                  purchasingValue
                                );
                              if (specialCharacterCustomerPurchasingId) {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  purchasingCompanyTaxId: "",
                                });
                              } else {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  purchasingCompanyTaxId:
                                    SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            }
                            const addCustomerFormData = {
                              ...customerEditAddress,
                              purchasingCompanyTaxId:
                                purchasingValue?.toLocaleLowerCase() === "n/a"
                                  ? "N/A"
                                  : purchasingValue || "",
                            };
                            setCustomerEditAddress(addCustomerFormData);
                          }}
                          onBlur={() => {
                            if (
                              customerEditAddress?.purchasingCompanyTaxId &&
                              customerEditAddress?.purchasingCompanyTaxId
                                ?.length > 0
                            ) {
                              var specialCharacterCustomerPurchasingId =
                                allowSpecialCharacterExcludingSome.test(
                                  customerEditAddress?.purchasingCompanyTaxId
                                );
                              if (customerEditAddress?.purchasingCompanyTaxId?.length > companyTaxIdCharacterLimit) {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  purchasingCompanyTaxId: COMPANY_TAXID_CHARACTER_LIMIT,
                                });
                              }
                              else if (specialCharacterCustomerPurchasingId) {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  purchasingCompanyTaxId: "",
                                });
                              } else {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  purchasingCompanyTaxId:
                                    SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            }
                          }}
                          errorMessage={
                            customerAddressError?.purchasingCompanyTaxId
                          }
                        />
                      )}
                      {props.addressType.toLocaleLowerCase() === "shipping" && (
                        <TextField
                          label="Shipment Company Tax ID"
                          styles={
                            userRole === UserRoles.GTFS
                              ? DisabledMediumTextFieldStyles
                              : MediumTextFieldStyles
                          }
                          readOnly={userRole === UserRoles.GTFS}
                          value={customerEditAddress?.shipmentCompanyTaxId}
                          onChange={(e, shippingIdValue) => {
                            if (
                              shippingIdValue &&
                              shippingIdValue?.length > 0
                            ) {
                              var specialCharacterCustomerShipmentId =
                                allowSpecialCharacterExcludingSome.test(
                                  shippingIdValue
                                );

                              if (specialCharacterCustomerShipmentId) {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  shipmentCompanyTaxId: "",
                                });
                              } else {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  shipmentCompanyTaxId:
                                    SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            }
                            const addCustomerFormData = {
                              ...customerEditAddress,
                              shipmentCompanyTaxId:
                                shippingIdValue?.toLocaleLowerCase() === "n/a"
                                  ? "N/A"
                                  : shippingIdValue || "",
                            };
                            setCustomerEditAddress(addCustomerFormData);
                          }}
                          onBlur={() => {
                            if (
                              customerEditAddress?.shipmentCompanyTaxId &&
                              customerEditAddress?.shipmentCompanyTaxId
                                ?.length > 0
                            ) {
                              var specialCharacterCustomerShipmentId =
                                allowSpecialCharacterExcludingSome.test(
                                  customerEditAddress?.shipmentCompanyTaxId
                                );
                              if (customerEditAddress?.shipmentCompanyTaxId?.length > companyTaxIdCharacterLimit) {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  shipmentCompanyTaxId: COMPANY_TAXID_CHARACTER_LIMIT,
                                });
                              }
                              else if (specialCharacterCustomerShipmentId) {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  shipmentCompanyTaxId: "",
                                });
                              } else {
                                setCustomerAddressError({
                                  ...customerAddressError,
                                  shipmentCompanyTaxId:
                                    SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                });
                              }
                            }
                          }}
                          errorMessage={
                            customerAddressError?.shipmentCompanyTaxId
                          }
                        />
                      )}
                      <TextField
                        label={
                          props.addressType.toLocaleLowerCase() === "shipping"
                            ? "Ship To SAP Account ID"
                            : "Bill To SAP Account ID"
                        }
                        styles={MediumTextFieldStyles}
                        value={customerEditAddress?.sapAccountId}
                        onChange={(e, sapAccountIdValue) => {
                          if (
                            sapAccountIdValue &&
                            sapAccountIdValue?.length > 0
                          ) {
                            var specialCharacterCustomerSapAccountId =
                              numbersOnly.test(sapAccountIdValue);
                            if (specialCharacterCustomerSapAccountId) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                sapAccountId: "",
                              });
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                sapAccountId: NUMBERS_ALLOWED,
                              });
                            }
                          }
                          const addCustomerFormData = {
                            ...customerEditAddress,
                            sapAccountId: sapAccountIdValue ?? "",
                          };
                          setCustomerEditAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerEditAddress?.sapAccountId &&
                            customerEditAddress?.sapAccountId?.length > 0
                          ) {
                            var specialCharacterCustomerSapAccountId =
                              numbersOnly.test(
                                customerEditAddress?.sapAccountId
                              );
                            if (specialCharacterCustomerSapAccountId) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                sapAccountId: "",
                              });
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                sapAccountId: NUMBERS_ALLOWED,
                              });
                            }
                          }
                        }}
                        errorMessage={customerAddressError?.sapAccountId}
                      />
                      <TextField
                        label="City"
                        styles={
                          userRole === UserRoles.GTFS
                            ? DisabledMediumTextFieldStyles
                            : MediumTextFieldStyles
                        }
                        readOnly={userRole === UserRoles.GTFS}
                        required
                        value={customerEditAddress?.city}
                        onChange={(e, cityValue) => {
                          if (cityValue && cityValue?.length > 0) {
                            var characterCustomerCity =
                              allowSpecialCharacterExcludingSome.test(
                                cityValue
                              );

                            if (characterCustomerCity) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                city: "",
                              });
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              city: CITY_REQUIRED,
                            });
                          }
                          const addCustomerFormData = {
                            ...customerEditAddress,
                            city: cityValue ?? "",
                          };
                          setCustomerEditAddress(addCustomerFormData);
                        }}
                        onBlur={() => {
                          if (
                            customerEditAddress?.city &&
                            customerEditAddress?.city?.length > 0
                          ) {
                            var characterCustomerCity =
                              allowSpecialCharacterExcludingSome.test(
                                customerEditAddress?.city
                              );

                            if (customerEditAddress?.city?.length > cityCharacterLimit) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                city: CITY_CHARACTER_LIMIT,
                              });
                            }
                            else if (characterCustomerCity) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                city: "",
                              });
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              city: CITY_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={customerAddressError?.city}
                      />
                      <ComboBox
                        styles={
                          userRole === UserRoles.GTFS
                            ? DisabledRegisterCountryBoxStyles
                            : customerNewAccountComboBoxStyleAuto
                        }
                        disabled={userRole === UserRoles.GTFS}
                        label="Country"
                        options={selectedBusinessSoldToCountry}
                        required
                        selectedKey={customerEditAddress?.country}
                        onChange={(e, countryValue) => {
                          if (countryValue && countryValue?.text.length > 0) {
                            var characterCustomerCountry = letters.test(
                              countryValue?.text.toString()
                            );
                            if (characterCustomerCountry) {
                              setCustomerAddressError({
                                ...customerAddressError,
                                country: "",
                              });
                            } else {
                              setCustomerAddressError({
                                ...customerAddressError,
                                country: CHARACTERS_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              country: COUNTRY_REQUIRED,
                            });
                          }
                          const addCustomerFormData = {
                            ...customerEditAddress,
                            country: countryValue?.text.toString() ?? "",
                          };
                          setCustomerEditAddress(addCustomerFormData);
                          const addressStateList = countryWiseStateList
                            .filter(
                              (x) =>
                                x.country.toLocaleLowerCase() ===
                                countryValue?.text.toLocaleLowerCase()
                            )
                            .sort((a, b) => a.text.localeCompare(b.text));
                          setEditAddressStateOptions(addressStateList);
                        }}
                        errorMessage={customerAddressError?.country}
                      />
                      <ComboBox
                        styles={
                          userRole === UserRoles.GTFS
                            ? DisabledRegisterCountryBoxStyles
                            : customerAddAddressComboBoxStyle
                        }
                        disabled={userRole === UserRoles.GTFS}
                        label="State/Province"
                        options={editAddressStateOptions}
                        required
                        selectedKey={customerEditAddress?.state}
                        onChange={(e, provinceValue) => {
                          if (provinceValue && provinceValue?.text.length > 0) {
                            setCustomerAddressError({
                              ...customerAddressError,
                              state: "",
                            });
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              state: PROVINCE_REQUIRED,
                            });
                          }
                          const addCustomerFormData = {
                            ...customerEditAddress,
                            state: provinceValue?.text.toString() ?? "",
                          };
                          setCustomerEditAddress(addCustomerFormData);
                        }}
                        errorMessage={customerAddressError?.state}
                      />
                      <ComboBox
                        label="Contacts"
                        placeholder="Select Contacts"
                        styles={
                          userRole === UserRoles.GTFS
                            ? DisabledRegisterCountryBoxStyles
                            : customerAddAddressComboBoxStyle
                        }
                        disabled={userRole === UserRoles.GTFS}
                        required
                        options={contactListKeyValuePair}
                        selectedKey={customerEditAddress?.contacts?.contactId?.toString()}
                        onChange={(e, contactValue) => {
                          if (contactValue && contactValue?.text.length > 0) {
                            setCustomerAddressError({
                              ...customerAddressError,
                              contacts: {
                                ...customerAddressError.contacts,
                                contactId: "",
                              },
                            });
                          } else {
                            setCustomerAddressError({
                              ...customerAddressError,
                              contacts: {
                                ...customerAddressError.contacts,
                                contactId: CONTACTS_REQUIRED,
                              },
                            });
                          }
                          const editCustomerFormData = {
                            ...customerEditAddress,
                            contacts: {
                              ...customerEditAddress.contacts,
                              contactId: contactValue?.key.toString() || "",
                            },
                          };
                          setCustomerEditAddress(editCustomerFormData);
                        }}
                        errorMessage={customerAddressError?.contacts.contactId.toString()}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              </form>
            </CoherencePanel>
          </div>
        )}
        {isContactPanelDisabled && (
          <div>
            <CoherencePanel
              panelSize="450px"
              headerText="New Contact"
              titleText="New Contact"
              isOpen={isContactOpen}
              onDismiss={dismissNewContactPanel}
              onRenderFooter={onRenderNewContactFooter}
              onRenderFooterContent={onRenderNewContactFooter}
              // You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
              closeButtonAriaLabel="Close"
            >
              <div>
                {editContactsSuccessMessage.showMessage && (
                  <MessageBar
                    messageBarType={MessageBarType.success}
                    onDismiss={() =>
                      setEditContactsSuccessMessage(
                        InitialStateOfResponseMessage
                      )
                    }
                  >
                    {editContactsSuccessMessage.message}
                  </MessageBar>
                )}
                {editContactsFailureMessage.showMessage && (
                  <MessageBar
                    messageBarType={MessageBarType.error}
                    onDismiss={() =>
                      setEditContactsFailureMessage(
                        InitialStateOfResponseMessage
                      )
                    }
                  >
                    {editContactsFailureMessage.message}
                  </MessageBar>
                )}
              </div>
              <form>
                <Stack verticalAlign="space-evenly" tokens={stackTokens}>
                  <Stack {...columnProps}>
                    <Stack>
                      <TextField
                        label="Contact First Name"
                        styles={MediumTextFieldStyles}
                        value={customerNewContact.contactFirstName}
                        required
                        onChange={(e, firstNameValue) => {
                          if (firstNameValue && firstNameValue?.length > 0) {
                            var characterCustomerContactFirstName =
                              allowSpecialCharacterExcludingSome.test(
                                firstNameValue
                              );
                            if (characterCustomerContactFirstName) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName:
                                  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactFirstName: "First Name is Required",
                            });
                          }
                          setCustomerNewContact({
                            ...customerNewContact,
                            contactFirstName: firstNameValue ?? "",
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerNewContact?.contactFirstName &&
                            customerNewContact?.contactFirstName?.length > 0
                          ) {
                            var characterCustomerContactFirstName =
                              allowSpecialCharacterExcludingSome.test(
                                customerNewContact?.contactFirstName
                              );
                            if (customerNewContact?.contactFirstName?.length > contactNameCharacterLimit) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName: CONTACT_FIRSTNAME_CHARACTER_LIMIT,
                              });
                            }
                            else if (characterCustomerContactFirstName) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName:
                                  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactFirstName: "First Name is Required",
                            });
                          }
                        }}
                        errorMessage={customerContactsError?.contactFirstName}
                      />
                      <TextField
                        label="Contact Last Name"
                        styles={MediumTextFieldStyles}
                        value={customerNewContact.contactLastName}
                        required
                        onChange={(e, lastNameValue) => {
                          if (lastNameValue && lastNameValue?.length > 0) {
                            var characterCustomerContactLastName =
                              allowSpecialCharacterExcludingSome.test(
                                lastNameValue
                              );
                            if (characterCustomerContactLastName) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName:
                                  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactLastName: "Last Name is Required",
                            });
                          }
                          setCustomerNewContact({
                            ...customerNewContact,
                            contactLastName: lastNameValue ?? "",
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerNewContact?.contactLastName &&
                            customerNewContact?.contactLastName?.length > 0
                          ) {
                            var characterCustomerContactLastName =
                              allowSpecialCharacterExcludingSome.test(
                                customerNewContact?.contactLastName
                              );
                            if (customerNewContact?.contactLastName?.length > contactNameCharacterLimit) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName: CONTACT_LASTNAME_CHARACTER_LIMIT,
                              });
                            }
                            else if (characterCustomerContactLastName) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName:
                                  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactLastName: "Last Name is Required",
                            });
                          }
                        }}
                        errorMessage={customerContactsError?.contactLastName}
                      />
                      <TextField
                        label="Contact Phone"
                        styles={MediumTextFieldStyles}
                        required
                        value={customerNewContact.contactPhone}
                        onChange={(e, phoneValue) => {
                          if (phoneValue && phoneValue?.length > 0) {
                            var characterCustomerContactPhone =
                              contactNumberRegex.test(phoneValue);

                            if (characterCustomerContactPhone) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactPhone: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactPhone:
                                  SPECIL_CHARACTER_INVALID_PHONENUMBER,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactPhone: AUTHORIZED_BUYER_PHONE_REQUIRED,
                            });
                          }
                          setCustomerNewContact({
                            ...customerNewContact,
                            contactPhone: phoneValue ?? "",
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerNewContact.contactPhone &&
                            customerNewContact.contactPhone?.length > 0
                          ) {
                            var checkLength = phoneNumberRegex.test(
                              customerNewContact.contactPhone
                            );
                            var characterCustomerContactPhone =
                              contactNumberRegex.test(
                                customerNewContact.contactPhone
                              );
                            if (characterCustomerContactPhone) {
                              if (!checkLength) {
                                setCustomerContactsError({
                                  ...customerContactsError,
                                  contactPhone: INVALID_PHONENUMBER,
                                });
                              } else {
                                setCustomerContactsError({
                                  ...customerContactsError,
                                  contactPhone: "",
                                });
                              }
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactPhone:
                                  SPECIL_CHARACTER_INVALID_PHONENUMBER,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactPhone: AUTHORIZED_BUYER_PHONE_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={customerContactsError?.contactPhone}
                      />
                      <TextField
                        label="Contact Email"
                        styles={MediumTextFieldStyles}
                        required
                        value={customerNewContact.contactEmail}
                        onChange={(e, emailValue) => {
                          if (emailValue && emailValue?.length > 0) {
                            var emailCustomerAuthorizedEmailId =
                              allowSpecialCharacterExcludingSome.test(
                                emailValue
                              );

                            if (emailCustomerAuthorizedEmailId) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactEmail: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactEmail:
                                  SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactEmail: AUTHORIZED_BUYER_EMAIL_REQUIRED,
                            });
                          }
                          setCustomerNewContact({
                            ...customerNewContact,
                            contactEmail: emailValue ?? "",
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerNewContact?.contactEmail &&
                            customerNewContact?.contactEmail?.length > 0
                          ) {
                            var emailCustomerAuthorizedEmailId =
                              allowSpecialCharacterExcludingSome.test(
                                customerNewContact?.contactEmail
                              );
                            var characterCustomerAuthorizedEmailId =
                              emailRegex.test(customerNewContact?.contactEmail);
                            if (customerNewContact?.contactEmail?.length > emailCharacterLimit) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactEmail: EMAIL_CHARACTER_LIMIT,
                              });
                            }
                            else if (emailCustomerAuthorizedEmailId) {
                              if (characterCustomerAuthorizedEmailId) {
                                setCustomerContactsError({
                                  ...customerContactsError,
                                  contactEmail: "",
                                });
                              } else {
                                setCustomerContactsError({
                                  ...customerContactsError,
                                  contactEmail: EMAIL_VALIDATION,
                                });
                              }
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactEmail:
                                  SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactEmail: AUTHORIZED_BUYER_EMAIL_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={customerContactsError?.contactEmail}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              </form>
            </CoherencePanel>
          </div>
        )}
        {isContactsEditButtonDisabled && (
          <div>
            <CoherencePanel
              panelSize="450px"
              headerText="Edit Contact"
              titleText="Edit Contact"
              isOpen={isContactOpen}
              onDismiss={dismissNewContactPanel}
              onRenderFooter={onRenderEditContactFooter}
              onRenderFooterContent={onRenderEditContactFooter}
              // You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
              closeButtonAriaLabel="Close"
            >
              <div>
                {editSelectedContactsSuccessMessage.showMessage && (
                  <MessageBar
                    messageBarType={MessageBarType.success}
                    onDismiss={() =>
                      setEditSelectedContactsSuccessMessage(
                        InitialStateOfResponseMessage
                      )
                    }
                  >
                    {editSelectedContactsSuccessMessage.message}
                  </MessageBar>
                )}
                {editSelectedContactsFailureMessage.showMessage && (
                  <MessageBar
                    messageBarType={MessageBarType.error}
                    onDismiss={() =>
                      setEditSelectedContactsFailureMessage(
                        InitialStateOfResponseMessage
                      )
                    }
                  >
                    {editSelectedContactsFailureMessage.message}
                  </MessageBar>
                )}
              </div>
              <form>
                <Stack verticalAlign="space-evenly" tokens={stackTokens}>
                  <Stack {...columnProps}>
                    <Stack>
                      <TextField
                        label="Contact First Name"
                        styles={MediumTextFieldStyles}
                        value={customerEditContact?.contactFirstName}
                        required
                        onChange={(e, firstNameValue) => {
                          if (firstNameValue && firstNameValue?.length > 0) {
                            var characterCustomerContactFirstName =
                              allowSpecialCharacterExcludingSome.test(
                                firstNameValue
                              );
                            if (characterCustomerContactFirstName) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName:
                                  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactFirstName: "First Name is Required",
                            });
                          }
                          setCustomerEditContact({
                            ...customerEditContact,
                            contactFirstName: firstNameValue ?? "",
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerEditContact?.contactFirstName &&
                            customerEditContact?.contactFirstName?.length > 0
                          ) {
                            var characterCustomerContactFirstName =
                              allowSpecialCharacterExcludingSome.test(
                                customerEditContact?.contactFirstName
                              );
                            if (customerEditContact?.contactFirstName?.length > contactNameCharacterLimit) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName: CONTACT_FIRSTNAME_CHARACTER_LIMIT,
                              });
                            }
                            else if (characterCustomerContactFirstName) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactFirstName:
                                  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactFirstName: "First Name is Required",
                            });
                          }
                        }}
                        errorMessage={customerContactsError?.contactFirstName}
                      />
                      <TextField
                        label="Contact Last Name"
                        styles={MediumTextFieldStyles}
                        value={customerEditContact?.contactLastName}
                        required
                        onChange={(e, lastNameValue) => {
                          if (lastNameValue && lastNameValue?.length > 0) {
                            var characterCustomerContactLastName =
                              allowSpecialCharacterExcludingSome.test(
                                lastNameValue
                              );
                            if (characterCustomerContactLastName) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName:
                                  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactLastName: "Last Name is Required",
                            });
                          }
                          setCustomerEditContact({
                            ...customerEditContact,
                            contactLastName: lastNameValue ?? "",
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerEditContact?.contactLastName &&
                            customerEditContact?.contactLastName?.length > 0
                          ) {
                            var characterCustomerContactLastName =
                              allowSpecialCharacterExcludingSome.test(
                                customerEditContact?.contactLastName
                              );
                            if (customerEditContact?.contactLastName?.length > contactNameCharacterLimit) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName: CONTACT_LASTNAME_CHARACTER_LIMIT,
                              });
                            }
                            else if (characterCustomerContactLastName) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactLastName:
                                  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactLastName: "Last Name is Required",
                            });
                          }
                        }}
                        errorMessage={customerContactsError?.contactLastName}
                      />
                      <TextField
                        label="Contact Phone"
                        styles={MediumTextFieldStyles}
                        required
                        value={customerEditContact?.contactPhone}
                        onChange={(e, phoneValue) => {
                          if (phoneValue && phoneValue?.length > 0) {
                            var characterCustomerContactPhone =
                              contactNumberRegex.test(phoneValue);

                            if (characterCustomerContactPhone) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactPhone: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactPhone:
                                  SPECIL_CHARACTER_INVALID_PHONENUMBER,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactPhone: AUTHORIZED_BUYER_PHONE_REQUIRED,
                            });
                          }
                          setCustomerEditContact({
                            ...customerEditContact,
                            contactPhone: phoneValue ?? "",
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerEditContact?.contactPhone &&
                            customerEditContact?.contactPhone?.length > 0
                          ) {
                            var checkLength = phoneNumberRegex.test(
                              customerEditContact?.contactPhone
                            );
                            var characterCustomerContactPhone =
                              contactNumberRegex.test(
                                customerEditContact.contactPhone
                              );

                            if (characterCustomerContactPhone) {
                              if (!checkLength) {
                                setCustomerContactsError({
                                  ...customerContactsError,
                                  contactPhone: INVALID_PHONENUMBER,
                                });
                              } else {
                                setCustomerContactsError({
                                  ...customerContactsError,
                                  contactPhone: "",
                                });
                              }
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactPhone:
                                  SPECIL_CHARACTER_INVALID_PHONENUMBER,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactPhone: AUTHORIZED_BUYER_PHONE_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={customerContactsError?.contactPhone}
                      />
                      <TextField
                        label="Contact Email"
                        styles={MediumTextFieldStyles}
                        required
                        value={customerEditContact?.contactEmail}
                        onChange={(e, emailValue) => {
                          if (emailValue && emailValue?.length > 0) {
                            var emailCustomerAuthorizedEmailId =
                              allowSpecialCharacterExcludingSome.test(
                                emailValue
                              );
                            if (emailCustomerAuthorizedEmailId) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactEmail: "",
                              });
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactEmail:
                                  SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactEmail: AUTHORIZED_BUYER_EMAIL_REQUIRED,
                            });
                          }
                          setCustomerEditContact({
                            ...customerEditContact,
                            contactEmail: emailValue ?? "",
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerEditContact?.contactEmail &&
                            customerEditContact?.contactEmail?.length > 0
                          ) {
                            var emailCustomerAuthorizedEmailId =
                              allowSpecialCharacterExcludingSome.test(
                                customerEditContact?.contactEmail
                              );
                            var characterCustomerAuthorizedEmailId =
                              emailRegex.test(
                                customerEditContact?.contactEmail
                              );
                            debugger;
                            if (customerEditContact?.contactEmail?.length > emailCharacterLimit) {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactEmail: EMAIL_CHARACTER_LIMIT,
                              });
                            }
                            else if (emailCustomerAuthorizedEmailId) {
                              if (characterCustomerAuthorizedEmailId) {
                                setCustomerContactsError({
                                  ...customerContactsError,
                                  contactEmail: "",
                                });
                              } else {
                                setCustomerContactsError({
                                  ...customerContactsError,
                                  contactEmail: EMAIL_VALIDATION,
                                });
                              }
                            } else {
                              setCustomerContactsError({
                                ...customerContactsError,
                                contactEmail:
                                  SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              });
                            }
                          } else {
                            setCustomerContactsError({
                              ...customerContactsError,
                              contactEmail: AUTHORIZED_BUYER_EMAIL_REQUIRED,
                            });
                          }
                        }}
                        errorMessage={customerContactsError?.contactEmail}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              </form>
            </CoherencePanel>
          </div>
        )}
      </Stack>
      <h2 style={{ marginLeft: "10px" }}>Contacts</h2>
      <Stack
        data-testid="customer-account-page"
        style={{
          height: 510,
          background: "white",
          marginLeft: "20px",
        }}
      >
        <div
          style={{
            alignItems: "flex-end",
          }}
        >
          <ActionButton
            iconProps={AddIcon}
            disabled={
              userRole === UserRoles.GTFS || isNewAddressSelected == false
                ? true
                : !isCustomerDisabled
            }
            onClick={() => {
              setCustomerContactsError(intialContactValue);
              setEditContactsSuccessMessage(InitialStateOfResponseMessage);
              setEditContactsFailureMessage(InitialStateOfResponseMessage);
              setIsContactPanelDisabled(true);
              openNewContact();
              setCustomerEditContact(intialEditContactValue);
            }}
          >
            Add
          </ActionButton>
          <ActionButton
            iconProps={EditIcon}
            disabled={
              userRole === UserRoles.GTFS ||
                (isEditAddressSelected == false &&
                  isCustomerEditButtonDisabled == true)
                ? true
                : isCustomerDisabled
            }
            onClick={() => {
              setCustomerContactsError(intialContactValue);
              openNewContact();
              setIsContactPanelDisabled(false);
              onClickEditContact();
            }}
          >
            Edit
          </ActionButton>
        </div>
        <CoherenceDataGrid
          ariaLabelForSelectAllCheckbox="select all checkbox"
          checkButtonAriaLabel="checkbox"
          compactMode="compact"
          selection={customerSelection}
          selectionMode={SelectionMode.single}
          selectionPreservedOnEmptyClick
          setKey="DATA_GRID_SORTABLE_SELECTABLE"
          data={updatedPrimaryContacts ?? []}
          isScrollable
          isSortable
          listConfig={[
            {
              fieldName: "contactFirstName",
              isResizable: true,
              key: "First Name",
              name: "First Name",
              type: "string",
            },
            {
              fieldName: "contactLastName",
              isResizable: true,
              key: "Last Name",
              name: "Last Name",
              type: "string",
            },
            {
              fieldName: "contactEmail",
              isResizable: true,
              key: "Email",
              name: "Email",
              type: "string",
            },
            {
              fieldName: "contactPhone",
              isResizable: true,
              key: "Phone",
              name: "Phone",
              type: "string",
            },
            {
              fieldName: "isContactPrimary",
              isResizable: true,
              key: "Primary",
              name: "Primary",
              type: "string",
            },
          ]}
        />

        <Stack>
          <PrimaryButton
            text="Save & Back"
            type="button"
            onClick={hanldeSubmitClick}
            style={
              screenScale === 1.5
                ? {
                  marginTop: "20px",
                  marginBottom: "100px",
                  width: "120px",
                  marginLeft: "400px",
                }
                : SaveAndBackButtonStyleShipping
            }
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
